// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"52df4356","395":"3cadda46"}[chunkId] + ".chunk.js";
};